import React from 'react';

import {getPhonemeDeletion} from 'constants/tests.js';

import AdminTestPanel from 'components/AdminTestPanel';
import {updateStepData} from 'api';
import strings from 'strings';
import AdminReadyButton from 'components/AdminReadyButton';
import StopWatch from 'components/StopWatch';
import CountDown from 'components/CountDown';

class PhonemeDeletionTestAdmin extends AdminTestPanel {
	constructor(props) {
		super(props, {
			enableTimers: false,
			enableHotkeys: false,
		});
		this.state = {
			...this.state,
			// Stop this test after six consecutive wrong or unanswered items.
			maxConsecutiveErrors: 6,
			stopOnConsecutiveErrors: true,
			key: 1,
			waitingForNeste: false,
		};
	}

	getTestName = () => {
		return strings.pd_testname;
	};

	shouldResetOnFreshAttempt = () => true;

	// Retakes reset countdown state and the consecutive-error stop settings.
	getFreshAttemptState = () => ({
		maxConsecutiveErrors: 6,
		stopOnConsecutiveErrors: true,
		key: 1,
		waitingForNeste: false,
	});

	updateTimeUsed = (timeUsed) => {
		let skipTime = this.state.skipTime;

		if (skipTime === timeUsed) {
			const newSkipTime = 30 + timeUsed;
			this.setState({
				timeElapsedLasAnsnwer: timeUsed,
				timeUsed: timeUsed,
				skipTime: newSkipTime,
				waitingForNeste: true,
			});
			updateStepData({timeExpired: true});
		} else {
			this.setState({
				timeUsed: timeUsed,
				timeElapsedLasAnsnwer: timeUsed,
			});
		}
	};

	handleNeste = () => {
		updateStepData({timeExpired: false});
		const newSkipTime = this.state.timeElapsedLasAnsnwer + 30;
		this.setState({waitingForNeste: false, skipTime: newSkipTime}, () => {
			this.answerUnanswered();
			this.handleCountdownComplete();
		});
	};
	answerWrong = () => {
		const {
			consecutiveErrors,
			currentStep,
			options,
			maxConsecutiveErrors,
			stopOnConsecutiveErrors,
		} = this.state;
		const newResults = Object.assign({}, this.state.results, {
			[currentStep]: {
				isCorrect: false,
				isAnswered: true,
			},
		});
		this.setState(
			{
				wrongAnswers: this.state.wrongAnswers + 1,
				results: newResults,
				consecutiveErrors: consecutiveErrors + 1,
			},
			() => {
				const currErrors = this.state.consecutiveErrors;
				const maxErrors = maxConsecutiveErrors;
				if (currErrors >= maxErrors && stopOnConsecutiveErrors) {
					if (options.enableTimers) this.props.endTimer();
					this.props.submitResults(this.state.results);
					this.props.nextStage();
				} else {
					if (options.enableTimers) this.props.endTimer();
					this.props.nextStep(this.state.results);
				}
			}
		);
		if (this.answerCB) this.answerCB();
	};

	answerUnanswered = () => {
		const {
			options,
			consecutiveErrors,
			currentStep,
			maxConsecutiveErrors,
			stopOnConsecutiveErrors,
		} = this.state;

		const newResults = Object.assign({}, this.state.results, {
			[currentStep]: {
				isCorrect: false,
				isAnswered: false,
			},
		});

		this.setState(
			{
				unanswered: this.state.unanswered + 1,
				results: newResults,
				consecutiveErrors: consecutiveErrors + 1,
			},
			() => {
				const currErrors = this.state.consecutiveErrors;
				const maxErrors = maxConsecutiveErrors;
				if (currErrors >= maxErrors && stopOnConsecutiveErrors) {
					if (options.enableTimers) this.props.endTimer();
					this.props.submitResults(this.state.results);
					this.props.nextStage();
				} else {
					if (options.enableTimers) this.props.endTimer();
					this.props.nextStep(this.state.results);
				}
			}
		);
		if (this.answerCB) this.answerCB();
	};

	handleCountdownComplete = () => {
		this.setState((prevState) => ({
			key: prevState.key < 20 ? prevState.key + 1 : 1,
		}));
	};

	renderIntro = () => {
		const {currentStep} = this.state;
		const introSteps = getPhonemeDeletion().getIntroSteps();
		const isPracticeTask =
			currentStep > 0 && currentStep < introSteps.length - 1;
		const {ageGroup} = this.props;
		const isNormingTest = ageGroup >= 2;
		return (
			<>
				<p>{strings.pd_admin1}</p>
				{currentStep === 0 && (
					<AdminReadyButton
						remoteIsReady={
							isNormingTest ? true : this.props.candidateReady
						}
						onClick={this.props.nextStep}
					/>
				)}
				{isPracticeTask && (
					<>
						{strings.formatString(
							strings.taskNum,
							introSteps[currentStep].task
						)}
						<br />
						{strings.formatString(
							strings.expectedAnswer,
							<b>{introSteps[currentStep].expectedAnswer}</b>
						)}
						<br />
						<button onClick={this.props.nextStep}>
							{strings.correctAnswerGiven}
						</button>
					</>
				)}
				{currentStep === 3 && (
					<>
						<p>{strings.pd_admin3}</p>
						<AdminReadyButton
							remoteIsReady={
								isNormingTest ? true : this.props.candidateReady
							}
							onClick={this.props.nextStage}
						/>
					</>
				)}
			</>
		);
	};

	renderTest = () => {
		const {currentStep, waitingForNeste} = this.state;
		const timeExpired =
			this.state.timeElapsedLasAnsnwer + 30 === this.state.skipTime;

		return (
			<div>
				<div className="lit-stop-watch-div">
					<StopWatch autoStart integer onTick={this.updateTimeUsed} />
				</div>
				<p>
					<br />
					{strings.pd_admin2}
					<br />
					{strings.buttonDescription}
				</p>
				<p>
					{strings.formatString(
						strings.taskNumOf,
						currentStep + 1,
						getPhonemeDeletion().getAnswers().length
					)}
				</p>
				<p>
					{strings.formatString(
						strings.taskNum,
						getPhonemeDeletion().getSteps()[currentStep]
					)}
					<br />
					{strings.formatString(
						strings.expectedAnswer,
						<b>{getPhonemeDeletion().getAnswers()[currentStep]}</b>
					)}
				</p>
				<div className="lit-all-buttons-div">
					<button
						disabled={timeExpired || waitingForNeste}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerCorrect();
							this.handleCountdownComplete();
						}}
					>
						{strings.buttonCorrect}
					</button>
					<button
						disabled={timeExpired || waitingForNeste}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerWrong();
							this.handleCountdownComplete();
						}}
					>
						{strings.buttonWrong}
					</button>
					<button
						disabled={timeExpired || waitingForNeste}
						onClick={(e) => {
							e.stopPropagation();
							const skipTime =
								30 + this.state.timeElapsedLasAnsnwer;
							this.setState({skipTime});
							this.answerUnanswered();
							this.handleCountdownComplete();
						}}
					>
						{strings.buttonUnanswered}
					</button>
					<div className="lit-count-down-div">
						{!waitingForNeste && (
							<CountDown
								key={this.state.key}
								duration={30}
								onComplete={() => {}}
							/>
						)}
						{waitingForNeste && (
							<button
								className="lit-neste-button"
								onClick={this.handleNeste}
							>
								Neste
							</button>
						)}
					</div>
				</div>
			</div>
		);
	};

	renderWaiting = () => {
		return (
			<div>
				<p>
					{strings.formatString(
						strings.testDone,
						strings.pd_testname
					)}
				</p>
				<button onClick={this.props.nextStage}>
					{strings.nextTest}
				</button>
			</div>
		);
	};
}

export default PhonemeDeletionTestAdmin;
